/**
 * Building codes and norms for staircase design.
 * Based on СП 54.13330.2022 (former СНиП 2.08.01-89) and the Blondel formula.
 */

export interface IStairNorms {
    riserHeightMin: number;
    riserHeightMax: number;
    riserHeightIdeal: number;
    treadDepthMin: number;
    treadDepthMax: number;
    treadDepthIdeal: number;
    angleMin: number; // degrees
    angleMax: number;
    headroomMin: number; // mm
    stairWidthMin: number;
    blondelMin: number; // 2h + g
    blondelMax: number;
    blondelIdeal: number;
    winderMinInnerDepth: number;
    winderMeasureOffset: number; // mm from the narrow edge where the winder depth is measured
    railingHeightMin: number;
    balusterSpacingMax: number;
}

export const RESIDENTIAL_NORMS: IStairNorms = {
    riserHeightMin: 150,
    riserHeightMax: 200,
    riserHeightIdeal: 175,
    treadDepthMin: 250,
    treadDepthMax: 300,
    treadDepthIdeal: 280,
    angleMin: 30,
    angleMax: 39,
    headroomMin: 2000,
    stairWidthMin: 800,
    blondelMin: 600,
    blondelMax: 640,
    blondelIdeal: 630,
    winderMinInnerDepth: 100,
    winderMeasureOffset: 150,
    railingHeightMin: 900,
    balusterSpacingMax: 150,
};
